var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 129,
    viewBox: "0 0 141 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 23.1C8.09961 16.4725 13.4722 11.1 20.0996 11.1H40.0986C53.5723 11.1 55.2565 23.1 72.0986 23.1H120.899C127.527 23.1 132.899 28.4726 132.899 35.1V105.5C132.899 112.127 127.527 117.5 120.899 117.5H20.0996C13.4722 117.5 8.09961 112.127 8.09961 105.5V23.1Z",
    fill: "#52AFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 23.1C8.09961 16.4725 13.4722 11.1 20.0996 11.1H40.0986C53.5723 11.1 55.2565 23.1 72.0986 23.1H120.899C127.527 23.1 132.899 28.4726 132.899 35.1V105.5C132.899 112.127 127.527 117.5 120.899 117.5H20.0996C13.4722 117.5 8.09961 112.127 8.09961 105.5V23.1Z",
    fill: "url(#paint0_linear_1795_12717)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1795_12717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5002 105.5C5.74966 99.4958 2.18264 58.2854 1.74438 53.2118C1.71477 52.8691 1.69656 52.5271 1.71112 52.1834C1.9817 45.7956 7.24587 40.7 13.7002 40.7L127.3 40.7C133.754 40.7 139.019 45.7956 139.289 52.1834C139.304 52.5271 139.286 52.8691 139.256 53.2118C138.818 58.2853 135.251 99.4957 134.5 105.5C133.7 111.9 129.128 117.5 122.5 117.5H18.5002C11.8728 117.5 7.3002 111.9 6.5002 105.5Z",
    fill: "#73D0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5002 105.5C5.74966 99.4958 2.18264 58.2854 1.74438 53.2118C1.71477 52.8691 1.69656 52.5271 1.71112 52.1834C1.9817 45.7956 7.24587 40.7 13.7002 40.7L127.3 40.7C133.754 40.7 139.019 45.7956 139.289 52.1834C139.304 52.5271 139.286 52.8691 139.256 53.2118C138.818 58.2853 135.251 99.4957 134.5 105.5C133.7 111.9 129.128 117.5 122.5 117.5H18.5002C11.8728 117.5 7.3002 111.9 6.5002 105.5Z",
    fill: "url(#paint1_radial_1795_12717)",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1795_12717",
    x: 1.70605,
    y: 32.7,
    width: 137.588,
    height: 84.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.686275 0 0 0 0 0.878431 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1795_12717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1795_12717",
    x1: 70.4986,
    y1: 29.5,
    x2: 70.4986,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00529E",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1795_12717",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5002 53.5) rotate(90) scale(48 76.8002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.f363450929d25ccc0712b165900b4dfc.svg";
export { ForwardRef as ReactComponent };